import * as React from 'react'
import * as css from './IconList.module.css'
import HexPatternSection from 'components/common/HexPatternSection'
import HTag from 'components/common/HTag'
import Img from 'components/common/Img'
import clsx from 'clsx'

const IconList = ({ heading, description, icons }) => (
  <section>
    <HexPatternSection>
      <header className="ctnr padding-x">
        <HTag className="h1" {...heading} />
        {!!description && <p className="mt-4 max-w-[480px]">{description}</p>}
      </header>
    </HexPatternSection>

    <ul className={clsx(css.items, 'ctnr padding-x')}>
      {icons?.map((item, key) => (
        <li className={css.item} key={key}>
          <Img image={item.icon} />
          <p className="h3 text-base">{item.text}</p>
        </li>
      ))}
    </ul>
  </section>
)

export default IconList
